import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'telephoneList',
    standalone: false
})
export class TelephoneListPipe implements PipeTransform {

  transform(value: any): any {
    const phoneList:Array<string> = value.split('/');
    const formatedPhoneList:Array<string> = [];
    phoneList.forEach(phone => {
      phone = phone.trim();
      if(phone.length>=9){
        const firstTwoDigit= phone.substring(0,2)
        if(firstTwoDigit==="91" || firstTwoDigit==="93" || firstTwoDigit==="81" || firstTwoDigit==="83") {
          const second3Digit = phone.substring(2,5);
          const third2Digit = phone.substring(5,7);
          const fourth2Digit = phone.substring(7,9);
          phone = `${firstTwoDigit} ${second3Digit} ${third2Digit} ${fourth2Digit}`;
        } else {
          const first3Digit = phone.substring(0,3);
          const second2Digit = phone.substring(3,5);
          const third2Digit = phone.substring(5,7);
          const fourth2Digit = phone.substring(7,9);
          phone = `${first3Digit} ${second2Digit} ${third2Digit} ${fourth2Digit}`;
        }
        phone = ` ${phone} `;
        formatedPhoneList.push(phone);
      } else {
        //Phone nos lesser than 9 charaters.
        formatedPhoneList.push(` ${phone} `);
      }
    });
    const result:string = formatedPhoneList.join('/')
    return result;
  }

}
